export const linkWithFilter = ({ base, type, page }) => {
	const pieces = [base];

	if (type) pieces.push(type);
	if ((page || 1) !== 1) pieces.push(page);

	return `/${pieces.join('/')}`;
};



// WEBPACK FOOTER //
// ./src/managers/newsAndEventsManager.js